export const fetchFolderSettings = async (apiClient) => {
  if (!apiClient) {
    throw new Error('API client is required to fetch folder settings');
  }
  const { data } = await apiClient.get('/folder');
  return data || [];
};

export const fetchFolderByPcName = async (apiClient, pcName) => {
  if (!apiClient) {
    throw new Error('API client is required to fetch folder settings');
  }
  const { data } = await apiClient.get(`/folder/pc/${encodeURIComponent(pcName)}`);
  return data;
};

export const addFolder = async (apiClient, pcName, folderPath) => {
  if (!apiClient) {
    throw new Error('API client is required to add folder settings');
  }
  const { data } = await apiClient.post('/folder', { pc_name: pcName, folder: folderPath });
  return data;
};

export const updateFolder = async (apiClient, id, updates) => {
  if (!apiClient) {
    throw new Error('API client is required to update folder settings');
  }
  const { data } = await apiClient.put(`/folder/${id}`, updates);
  return data;
};

export const deleteFolder = async (apiClient, id) => {
  if (!apiClient) {
    throw new Error('API client is required to delete folder settings');
  }
  await apiClient.delete(`/folder/${id}`);
};
